<style>
    .selectable-row {
        cursor: pointer;
    }
</style>
<template>
    <div class="table-responsive" style=" height:100%;">
        <a v-shortkey="{ keys:'0', title:'Table Selection', description:'Select #0 Row'}" @shortkey="selectRow('0')" />
        <a v-shortkey="{ keys:'1', title:'Table Selection', description:'Select #1 Row'}" @shortkey="selectRow('1')" />
        <a v-shortkey="{ keys:'2', title:'Table Selection', description:'Select #2 Row'}" @shortkey="selectRow('2')" />
        <a v-shortkey="{ keys:'3', title:'Table Selection', description:'Select #3 Row'}" @shortkey="selectRow('3')" />
        <a v-shortkey="{ keys:'4', title:'Table Selection', description:'Select #4 Row'}" @shortkey="selectRow('4')" />
        <a v-shortkey="{ keys:'5', title:'Table Selection', description:'Select #5 Row'}" @shortkey="selectRow('5')" />
        <a v-shortkey="{ keys:'6', title:'Table Selection', description:'Select #6 Row'}" @shortkey="selectRow('6')" />
        <a v-shortkey="{ keys:'7', title:'Table Selection', description:'Select #7 Row'}" @shortkey="selectRow('7')" />
        <a v-shortkey="{ keys:'8', title:'Table Selection', description:'Select #8 Row'}" @shortkey="selectRow('8')" />
        <a v-shortkey="{ keys:'9', title:'Table Selection', description:'Select #9 Row'}" @shortkey="selectRow('9')" />
        
        <table class="table table-striped table-hover" style="width:100%;" :name="tablename">
            <thead>
                <tr>
                    <th v-for="item in columns">{{ item.name }}</th>
                </tr>
            </thead>
        </table>
        <br />
        <br />
        <br />
    </div>
</template>
<script>

    import $ from 'jquery';
    import dt from 'datatables.net-bs';
    import 'datatables.net-bs/css/dataTables.bootstrap.css';

    export default {
        props: ['tablename', 'columns', 'source', 'datachanged', 'suppressrowselected'],
        watch: {
            datachanged: function () {
                console.log("Table data changed notified")
                this.dtHandle.ajax.reload();
                this.dtHandle.draw();
            }
        },
        data: function () {
            return {
                dtHandle: null
            }
        },
        methods: {
            selectRow(index) {
                var row = this.dtHandle.row(index).data();
                this.$emit('selected', row)
            }
        },
        mounted() {
            let that = this;
            var $table = $(this.$el).find("table");

            var columns = this.columns;
            console.log("Data table mounted with suppressrowselected,", this.suppressrowselected)
            var datasource = this.source;
            //Instantiate the datatable and store the reference to the instance in our dtHandle element.
            var datatable = $table.DataTable({
                stateSave: true,
                serverSide: true,
                "dom": '<"row"<"col-sm-6 col-xs-12"l><"col-sm-6 col-xs-12"f>>rt<"row"<"col-sm-6 col-xs-12  pull-left"i><"col-xs-12 col-sm-6  pull-left"p>>',
                "ajax": function (data, callback, settings) {
                    console.log("Getting Table Data", data, settings)

                    let sortDirection = null;
                    let sortColumnName = null;
                    sortColumnName
                    if (data.order.length > 0) {
                        var sortColumn = data.order[0].column;
                        sortDirection   = data.order[0].dir;
                        sortColumnName = data.columns[sortColumn].data
                        sortColumnName = sortColumnName.charAt(0).toUpperCase() + sortColumnName.slice(1);
                    }

                    datasource(data.draw ,data.start, data.length, data.search.value, sortColumnName, sortDirection, callback);
                },
                "language": {
                    "search": "Filter:"
                },
                columns: columns,
                buttons: ['pageLength', 'copy'],
                createdRow: function (row, data, index) {
                    if (!that.suppressrowselected) {
                        $(row).addClass("selectable-row");
                    }
                },
                stateSaveCallback: function (settings, data) {
                    localStorage.setItem(that.tablename, JSON.stringify(data));
                },
                stateLoadCallback: function (settings, callback) {
                    var data = localStorage.getItem(that.tablename);
                    if (data) {
                        callback(JSON.parse(data));
                    } else {
                        callback({});
                    }
                }

            });

            that.dtHandle = datatable;
            $table.on('click', 'tbody tr', function () {
                var row = datatable.row($(this)).data();
                that.$emit('selected', row)
            })
        }
    }
</script>


// WEBPACK FOOTER //
// serverDatatable.scp.html?0bb21492